const components = {
  MuiCssBaseline: {
    styleOverrides: {
      '*': {
        boxSizing: 'border-box',
      },
      html: {
        height: '100%',
        width: '100%',
      },
      body: {
        height: '100%',
        margin: 0,
        padding: 0,
      },
      '#root': {
        height: '100%',
      },
      "*[dir='rtl'] .buyNowImg": {
        transform: 'scaleX(-1)',
      },

      '.buyNowImg': {
        position: 'absolute',
        right: '-44px',
        top: '-18px',
        width: '143px',
        height: '175px',
      },
      '.MuiCardHeader-action': {
        alignSelf: 'center !important',
      },
      '.scrollbar-container': {
        borderRight: '0 !important',
      },
      "*[dir='rtl'] .welcomebg:before": {
        backgroundPosition: 'top -24px left -9px !important',
      },
    },
  },

  MuiContainer: {
    styleOverrides: {
      root: {
        paddingLeft: '15px !important',
        paddingRight: '15px !important',
        // marginLeft: 'unset',
        // marginRight: 'unset',
        maxWidth: '1600px',
        paddingBottom: '50px',
      },
    },
  },

  MuiPaper: {
    styleOverrides: {
      root: {
        position: 'relative',
        '.sidebar': {
          padding: '0px',
          // '16px 16px 16px 47px',
          zIndex: '9999999',
          '.MuiBox-root.logo': {
            padding: '0px',
            marginBottom: '0px'
          },
        },
      },
    },
  },

  MuiButton: {
    styleOverrides: {
      root: {
        textTransform: 'none',
        boxShadow: 'none',

        '&:hover': {
          boxShadow: 'none',
        },
      },
    },
  },

  MuiIconButton: {
    styleOverrides: {
      root: {
        position: 'fixed',
        top: '10px',
        left: '10px',
        zIndex: '999',
      },
    },
  },

  MuiList: {
    styleOverrides: {
      root: {
        // marginLeft: "10px"
      },
    },
  },

  MuiListItem: {
    styleOverrides: {
      root: {
        borderRadius: '0',
        paddingRight: '0',
        paddingLeft: '30px',
        paddingTop: '2px',
        paddingBottom: '2px',
        marginBottom: '16px !important',
        width: '97%'
      },
    },
  },

  MuiCard: {
    styleOverrides: {
      root: {
        borderRadius: '10px',
        padding: '0',
        margin: '15px',
        boxShadow: '0px 7px 30px 0px rgba(90, 114, 123, 0.11)',
        h4: {
          color: '#08364f',
          fontWeight: '600',
          fontSize: '1.1rem',
        },
        h5: {
          color: '#08364f',
          fontWeight: '600',
          fontSize: '1.35rem',
          lineHeight: 'inherit',
          marginBottom: '0px',
        },
        span: {
          color: '#08364f',
          fontSize: '1.35rem',
        },
        p: {
          color: '#B3B3B3',
          fontSize: '14px',
          marginBottom: '20px',
        },
        'p.right': {
          position: 'absolute',
          bottom: '15px',
          right: '25px',
          marginBottom: '0px!important',
          // float: "right",
          // marginBottom: "0px",
          // marginTop: "0.5rem"
        },
        'p.primary': {
          color: '#34c534',
        },
        'p.yellow': {
          color: '#ffa110',
        },
        'p.red': {
          color: 'red',
        },
        legend: {
          color: '#08364f',
          fontSize: '0.9rem',
          fontWeight: '500',
        },
        'p.min-height': {
          marginBottom: '0px',
          lineHeight: '1.5',
        },
        'p.min-height.last-child': {
          marginBottom: '0.85rem',
        },
        'p.available': {
          color: 'green',
        },
        'p.request-pending': {
          color: '#E9961F',
        },
        'p.pending-request': {
          color: '#ffaf67',
        },
        'p.action-required': {
          color: 'red',
        },
      },
    },
  },

  MuiListItemIcon: {
    styleOverrides: {
      root: {
        minWidth: '40px',
      },
    },
  },

  MuiGrid: {
    styleOverrides: {
      root: {
        '.order-summary': {
          '.MuiBox-root': {
            padding: '10px 16px 10px 16px',
          },
          '.MuiCardContent-root': {
            padding: '20px 16px 5px 16px',
          },
        },
        '.order-overview': {
          '.MuiCardContent-root': {
            paddingBottom: '15px',
          },
        },
      },
    },
  },

  MuiGridItem: {
    styleOverrides: {
      root: {
        paddingTop: '30px',
        paddingLeft: '30px !important',
      },
    },
  },

  MuiLinearProgress: {
    styleOverrides: {
      root: {
        backgroundColor: '#ecf0f2',
        borderRadius: '6px',
      },
    },
  },

  MuiMenuItem: {
    styleOverrides: {
      root: {
        borderRadius: '0',
      },
    },
  },

  MuiChip: {
    styleOverrides: {
      root: {
        fontWeight: '500',
        fontSize: '0.75rem',
      },
    },
  },

  MuiTable: {
    styleOverrides: {
      root: {
        marginTop: '0px!important',
      },
    },
  },

  MuiTableHead: {
    styleOverrides: {
      root: {
        color: '#08364f',
      },
    },
  },

  MuiTableCell: {
    styleOverrides: {
      root: {
        padding: '10px',
        borderBottom: 'unset',
      },
      head: {
        h6: {
          color: '#08364f',
          fontWeight: '500',
        },
      },
    },
  },

  MuiCardContent: {
    styleOverrides: {
      root: {
        overflow: 'auto!important',
        '&:last-child': {
          paddingBottom: '6px',
        },
      },
    },
  },

  MuiTypography: {
    styleOverrides: {
      root: {
        fontFamily: 'Poppins, sans-serif',
        fontWeight: '400',
      },
    },
  },

  MuiListItemText: {
    styleOverrides: {
      root: {
        span: {
          fontWeight: '500',
          fontSize: '16px',
          color: '#A3AED0'
        },
      },
    },
  },

  MuiFormControlLabel: {
    styleOverrides: {
      root: {
        display: 'block',
        paddingTop: '0px',
        paddingBottom: '0px',
        marginBottom: '0px',
        span: {
          fontWeight: 'normal',
          fontSize: '0.88rem',
          paddingTop: '0px',
          paddingBottom: '0px',
        },
      },
    },
  },
}

export default components
